// extracted by mini-css-extract-plugin
export default {"auth-container":"Auth_auth-container__prXyr","auth-form":"Auth_auth-form__dwLEK","auth-link":"Auth_auth-link__H+1Jq"};